
import MainCardsComponent from '../components/Cards-wrapper/MainCardsComp.vue';
import { defineComponent } from 'vue';
import CategoryBoxesComponent from '../components/Category-boxes/CategoryBoxesComp.vue';
import MainHeaderComponent from '../components/Main-header/MainHeaderComp.vue';
import SortHeaderComp from '../components/Main-header/SortHeaderComp.vue';
import CatalogCardsComp from '../components/Cards-wrapper/CatalogCardsComp.vue'
import NoveltiesCardsComponent from '../components/Cards-wrapper/NoveltiesCardsComp.vue'
import { mapActions } from 'vuex'
import DataMixins from "@/mixins/DataMixins";
import {useHead} from "@unhead/vue";
import { Head } from '@unhead/vue/components'

interface State {
  sortBy: string,
}

export default defineComponent({
  name: 'ModsView',
  components: {
      CategoryBoxesComponent,
      MainHeaderComponent,
      MainCardsComponent,
      CatalogCardsComp,
      SortHeaderComp,
      NoveltiesCardsComponent,
      Head
  },
  data: (): State => ({
      sortBy: '-created_at',
  }),
  computed: {
    game() {
      return this.$route.params.game as string;
    },
    category() {
      return this.$route.query.category as string
    },
    page() {
      return this.$route.query.page as string
    },
    metaTitle() {
      const category = this.category ? `на ${this.getPrettyCategory(this.category)}` : '',
            game = this.game ? `${this.getPrettyGame(this.game)}` : ''
      return `ModBox: Скачать моды ${category ? category.toLowerCase()+' ' : '' }для игры ${game}`
    },
    metaDesc() {
      const game = this.game ? `${this.getPrettyGame(this.game)}` : ''
      return `Большая коллекция модов для ${game}. Расширьте возможности вашей гоночной игры с помощью качественных модификаций на машины, карты, тюнинг!`
    },
  },
  methods: {
    ...mapActions(["uploadCatalogMods", "uploadPopularMods", "uploadNoveltyMods"]),
    applySortByParam(sort_by: string) {
      this.sortBy = sort_by

      const game = this.game
      const category = this.category
      const page = this.page

      this.uploadCatalogMods({game: game,
        category: category,
        page: page,
        sort: this.sortBy
      }).then(() => {
        this.$store.commit("disablePopularModsPreloader")
        this.$store.commit("disableNoveltyModsPreloader")
      })
    },
    uploadMods(game: string, category: string, page: string) {
      return new Promise((resolve: any) => {
        this.uploadPopularMods({game: game,
          category: category,
          sort: '-views'
        })
        this.uploadCatalogMods({game: game,
          category: category,
          page: page,
          sort: this.sortBy
        })
        this.uploadNoveltyMods({game: game,
          category: category,
          sort: '-created_at'
        })

        resolve()
      })
    },
  },
  mixins: [DataMixins],
  setup() {
    useHead({
      meta: [
        {
          name: 'charset',
          content: 'utf-8'
        },
        {
          name: 'theme-color',
          content: '#fff'
        }
      ],
    });
  },
  beforeRouteUpdate(to: any, from: any, next: any) {
    const page = this.page as string

    if(to.query.page !== from.query.page
        && to.query.category == from.query.category
        && to.params.game == from.params.game
    ) {
      this.uploadCatalogMods({game: to.params.game,
        category: to.query.category,
        page: to.query.page,
        sort: this.sortBy
      }).then(() => {
        this.$store.commit("disablePopularModsPreloader")
        this.$store.commit("disableNoveltyModsPreloader")
      })

      next();
      return;
    }


    if(to.params.game !== from.params.game ||
        to.query.category !== from.query.category
    ) {
      this.uploadMods(to.params.game, to.query.category, page).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  created() {
    const game = this.game
    const category = this.category
    const page = this.page

    this.uploadMods(game, category, page)
  },
});
